import type { TOC } from '@ember/component/template-only'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { ContentTile } from 'teacher-ui-client/components/tiles/content'
import { t } from 'ember-intl'
import type { Theme } from 'teacher-ui-client/components/page/book-library/shares/new'
import type { ThemeKeys } from 'teacher-ui-client/utils/themes'
import { BookLibraryDateRange } from 'teacher-ui-client/components/book-library/date-range'

interface Signature {
  Element: Element
  Args: {
    selectedTheme?: Theme
    startDate: Date
    endDate: Date
    onDateSelect?: ({ startDate, endDate }: { startDate: Date; endDate?: Date | null }) => unknown
    themeKey: ThemeKeys
  }
}

export const BookLibraryShareExpiryTile: TOC<Signature> = <template>
  <ContentTile ...attributes>
    <div class="flex items-center p-4 {{@selectedTheme.panelHeaderBgColor}}">
      <span class="mr-2 flex h-10 w-10 items-center justify-center rounded-full bg-white">
        <PhosphorIcon @icon="phosphor-bell-fill" class="{{@selectedTheme.panelHeaderIconColor}} h-7 w-7" />
      </span>
      <h3>{{t "bookLibrary.collection.share.expiryPanelHeader"}}</h3>
    </div>
    <BookLibraryDateRange
      class="m-4 lg:m-6 xl:m-8"
      @startDate={{@startDate}}
      @endDate={{@endDate}}
      @onDateSelect={{@onDateSelect}}
      @themeKey={{@themeKey}}
    />
  </ContentTile>
</template>

export default BookLibraryShareExpiryTile
